import React from "react"
import { z } from "zod"

const StartParamsSchema = z.object({
  id: z.number().optional(),
  username: z.string().optional(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  chat_id: z.number().optional(),
  redirect_url: z.string().toLowerCase().optional(),
})
export type TelegramStartParams = z.infer<typeof StartParamsSchema>

// useTelegramStartParams returns the Telegram start params, both raw and parsed.
export const useTelegramStartParams = (init: URLSearchParams) => {
  const raw = React.useMemo(() => {
    switch (true) {
      case init.has('start_param'):
        return init.get('start_param')
      case init.has('tgWebAppData'):
        return init.get('tgWebAppData')
      case init.has('tgWebAppStartParam'):
        return init.get('tgWebAppStartParam')
      default:
        return null
    }
  }, [init])

  const params = React.useMemo(() => {
    if (!raw) return null

    const json = atob(raw)
    const data = JSON.parse(json)
    return StartParamsSchema.parse(data)
  }, [raw])

  return React.useMemo(() => ({ raw, params }), [raw, params])
}

